export default __webpack_public_path__ + "static/media/3536 spice rack E side.78b72c47.png";